import { createContext } from "react";

export const LocaleOverrideContext = createContext<string | undefined>(
  undefined
);
